<ng-container *transloco="let t; read: 'home.calculator.register-for-full'">
  <ng-container *ngIf="buttonOnly; else dialog">

    <psc-button
      (buttonClicked)="onButtonClick()"
      [label]="authService.userLoggedIn() ?  t('click-to-pay') : t('click-to-register')">
    </psc-button>
  </ng-container>
  <ng-template #dialog>
    <div
      class="p-10 bg-blue1 shadow-3xl bg-opacity-90 rounded-lg flex flex-col gap-8 items-center">
      <div class="font-bold text-2xl text-white rounded-lg text-center p-1">
        {{t('title')}}
      </div>

      <psc-button
        type="primary-blue-2"
        (buttonClicked)="onButtonClick()"
        [label]="authService.userLoggedIn() ?  t('click-to-pay') : t('click-to-register')">
      </psc-button>
    </div>

  </ng-template>
</ng-container>
